import React from 'react';
import ReadArticleListFilter from "./ReadArticleListFilter";

export default function ReadArticleListNav(props) {
    return (
        <div className="readArticleListNav flex flex-row text-white  justify-between items-center">
            <div className="readArticleListNav-title text-xl">Articles</div>

            {/*Disabled until implemented*/}
            {/*<ReadArticleListFilter />*/}

        </div>
    );
}


